import { useDispatch } from "react-redux";

import MLSystemIcon from "../../../../Icon-SVG/MLSystemIcon";
import { setModalActive, setModalParams } from "../../../../../store/actions/dashboardActions";
import { isCompressedItself } from "../../../../../utils/function";

const CheckWithAI = (props) => {
  const dispatch = useDispatch();
  // console.log(props.row.original);
  const clickHandler = (e) => {
    const fileName = props?.row?.original?.file?.name || "-";
    const classification = (props.row.original.apt?.aptClasses || []).join(", ");
    const id = props.row.original.id;
    const compressedID = props.row.original.compressedID;
    const compressedIDfull = props.row.original.compressedIDfull;

    if (isCompressedItself(compressedID, compressedIDfull, id)) {
      return;
    } else {
      e.stopPropagation();
    }

    const customPromptSuggestions = [
      "Can you list and explain the malicious activities of " + fileName + " ? <" + id + ">",
      "Why " +
        fileName +
        " report shows us " +
        classification +
        " classification and give me details for " +
        classification +
        " ? <" +
        id +
        ">",
      "Could you list the generated IOCs from " + fileName + " ? <" + id + ">",
      "Can you see any network activity at " +
        fileName +
        " report ? and explain them if there is ? <" +
        id +
        ">",
    ];

    // First set the parameters, then activate the modal
    dispatch(
      setModalParams({
        promptSuggestions: customPromptSuggestions,
        opensession: true,
      }),
    );

    // Now open the modal
    dispatch(setModalActive(true));
  };
  return (
    <button className="listGroup__check-with-ai" style={{ width: "auto" }} onClick={clickHandler}>
      <MLSystemIcon color="white" height={20} width={20} />
    </button>
  );
};
export default CheckWithAI;
